/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CookiesView
 */
export interface CookiesView {
    /**
     * 
     * @type {string}
     * @memberof CookiesView
     */
    contentBefore: string;
    /**
     * 
     * @type {string}
     * @memberof CookiesView
     */
    contentBeforeName: string;
    /**
     * 
     * @type {string}
     * @memberof CookiesView
     */
    contentAfter: string;
    /**
     * 
     * @type {string}
     * @memberof CookiesView
     */
    contentAfterName: string;
}

/**
 * Check if a given object implements the CookiesView interface.
 */
export function instanceOfCookiesView(value: object): value is CookiesView {
    if (!('contentBefore' in value) || value['contentBefore'] === undefined) return false;
    if (!('contentBeforeName' in value) || value['contentBeforeName'] === undefined) return false;
    if (!('contentAfter' in value) || value['contentAfter'] === undefined) return false;
    if (!('contentAfterName' in value) || value['contentAfterName'] === undefined) return false;
    return true;
}

export function CookiesViewFromJSON(json: any): CookiesView {
    return CookiesViewFromJSONTyped(json, false);
}

export function CookiesViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CookiesView {
    if (json == null) {
        return json;
    }
    return {
        
        'contentBefore': json['contentBefore'],
        'contentBeforeName': json['contentBeforeName'],
        'contentAfter': json['contentAfter'],
        'contentAfterName': json['contentAfterName'],
    };
}

export function CookiesViewToJSON(value?: CookiesView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contentBefore': value['contentBefore'],
        'contentBeforeName': value['contentBeforeName'],
        'contentAfter': value['contentAfter'],
        'contentAfterName': value['contentAfterName'],
    };
}

